// Keep invitation returns local and narrowly allowlisted; never accept arbitrary redirects.
export const safeAuthNext = next => typeof next === 'string' &&
  (/^\/join\/[a-zA-Z0-9_-]+$/.test(next) || /^\/player-passport\/invitations\/[a-f0-9]{64}$/.test(next)
    || /^\/coach-invite\/[a-f0-9]{64}$/.test(next)) ? next : null;